import React from "react";
import PropTypes from "prop-types";
import { TextField } from "@material-ui/core";
import Button from "../Button";
import Icon from "../Icon";

const SearchInput = ({ onChange, value, onSearch, showLabel }) => {
    const onKeyDownHandler = (e) => {
        e.stopPropagation();
        if (e.key === "Enter") {
            e.preventDefault();
            onSearch(value);
        }
    };

    return (
        <div className="filter-input-box">
            <TextField
                value={value || ""}
                onChange={onChange}
                onKeyDown={onKeyDownHandler}
                label={showLabel ? "Type to search" : undefined}
                size="small"
                fullWidth
            />
            <Button
                small
                outline
                secondary
                onClick={() => {
                    onChange({ target: { value: "" } });
                    onSearch(undefined);
                }}
            >
                <Icon name="cancel" size="sm" color="secondary" />
            </Button>
        </div>
    );
};

SearchInput.propTypes = {
    onChange: PropTypes.func,
    value: PropTypes.string,
    onSearch: PropTypes.func,
    showLabel: PropTypes.bool,
};

SearchInput.defaultProps = {
    onChange: () => {},
    value: "",
    onSearch: () => {},
    showLabel: true,
};

export default SearchInput;
